import request from './AxiosRequest';

const updateReblastIsFeatured = (data) =>
	request({
		method: 'POST',
		url: '/Services/api/reblast/updatereblastisfeatured',
		data
	});

const Reblast = {
	updateReblastIsFeatured: updateReblastIsFeatured
};

export default Reblast;
